import { render, staticRenderFns } from "./retailerItemProduct.vue?vue&type=template&id=284e2d63&scoped=true"
import script from "./retailerItemProduct.vue?vue&type=script&lang=js"
export * from "./retailerItemProduct.vue?vue&type=script&lang=js"
import style0 from "./retailerItemProduct.vue?vue&type=style&index=0&id=284e2d63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e2d63",
  null
  
)

export default component.exports